import { ParticipantMarketStatus, ParticipantOption, ParticipantPriceType } from '@cds/betting-offer';

import { BetslipV2WinParticipantPick } from '../../../core/picks/betslip-v2-win-participant-pick';
import { BetslipV2ParticipantPickUpdater } from './betslip-v2-participant-pick.updater';

export class BetslipV2WinParticipantPickUpdater extends BetslipV2ParticipantPickUpdater {
    override updateFromParticipantOptions(pick: BetslipV2WinParticipantPick, markets: ParticipantOption[]): void {
        super.updateFromParticipantOptions(pick, markets);
        if (markets.length) {
            const fixedMarket = markets.find((m) => m.priceType === ParticipantPriceType.Fixed);
            const startingPriceMarket = markets.find((m) => m.priceType === ParticipantPriceType.StartingPrice);
            pick.market.isStartingPriceAvailable = !!(startingPriceMarket && startingPriceMarket.marketStatus === ParticipantMarketStatus.Visible);
            pick.market.isVisible = !!(fixedMarket && fixedMarket.marketStatus === ParticipantMarketStatus.Visible);
            pick.market.isEachWay = fixedMarket?.properties.isEachWay || false;
            pick.market.placeTerms = fixedMarket?.properties.placeTerms || null;
        }
    }
}
